<template>
    <section class="cta introslide flex flex-col justify-center bg-workbook-orange" :class="props.class">
    <UContainer>
      <div class="flex py-12 md:py-32 flex-col items-center justify-center">        
        <NuxtLink :to="props.to" class="text-white flex items-center justify-center gap-2 md:gap-12">
          <slot/><UIcon name="workbook-arrow-right" class="size-5 md:size-12"/>
        </NuxtLink>
        </div>
    </UContainer>
  </section>
</template>

<script lang="ts" setup>

const props = defineProps({
  to: {
    type: String,
    default: '/'
  },
  class: {
    type: String,
    default: ''
  }
})

</script>

<style scoped>
@reference "../../assets/css/main.css";
  :deep(h1) {
    @apply text-2xl md:text-6xl m-0
  }

  .cta.dark{
  @apply bg-workbook-black;
}
</style>

